// extracted by mini-css-extract-plugin
export var closeButton = "bL_fv";
export var dialogWrapper = "bL_fw";
export var mainContent = "bL_D";
export var modalWrapper = "bL_ft";